/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
import { SvgIcons } from '../svgIcons';
// import correctSound from '../../../../assets/sounds/correct.mp3';
// import wrongSound from '../../../../assets/sounds/wrong.mp3';
// import solveSound from '../../../../assets/sounds/solve.mp3';
import CanvasManager from '../managers/CanvasManager';
import { PageItemCanvasModel } from '@/types';


export interface Props {
  currentPageItem: PageItemCanvasModel;
  onQuestionFileClick: (file: any) => void;
  activityBackgroundImage: string;
  tool?: string;
}
let openedAnswerIds: string[] = [];
let canPlaySound = true;

class FabricCanvasExercise {
  protected _canvas: CanvasManager;
  line: any;
  selectedTool: string ='';

  constructor(canvas: CanvasManager) {
    this._canvas = canvas;
  }

  configureCanvas(props: Props) {
    this.selectedTool = props.tool ?? '';
  }

  drawLine = (source: any): void => {
    const points = [
      source.originalLeft,
      source.originalTop + ((source.height * (source.scaleY ?? 1))) / 2,
      source.originalLeft,
      source.originalTop + (source.height * (source.scaleX ?? 1)) / 2,
    ];
    this.line = new fabric.Line(points, {
      id: `sourceline-${source.id}`,
      strokeWidth: 5,
      opacity: 1,
      clearOnReset: true,
      pageIcon: true,
      optionId: source.id,
      fill: '',
      stroke: 'red',
      originX: 'center',
      originY: 'center',
      selectable: false,
      evented: false
    });

    this._canvas.addObject(this.line);
    this.line.moveTo(10000);

    this.line.animate(
      {
        x2: source.originalLeft + (source.width * (source.scaleX ?? 1)),
      },
      {
        onChange: () => {
          this.line.bringToFront();
          this._canvas.canvasRenderAll();
        },
        onComplete: () => {},
        duration: 400
      }
    );

    source.set('evented', false);
    source.set('opacity', 0);
    source.set('isDisable', true);
    this._canvas.canvasRenderAll();
  };

  removeDrawLine = (removedElement: any): void => {
    const source = this._canvas
      .getObjects()
      .find((x: any) => x.optionId === removedElement.optionId && x.isMain);

    if (source && source.isDisable) {
      source.set('evented', true);
      source.set('opacity', 1);
      source.set('isDisable', false);

      const line = this._canvas
        .getObjects()
        .find((x: any) => x.id === `sourceline-${source.id}`);

      if (line) {
        this._canvas.removeObject(line);
        this._canvas.canvasRenderAll();
      }
    }
  };

  underlineObject = (source: any): void => {
    const points = [
      source.left ?? 0,
      (source.top +source.height),
      source.left ?? 0,
      (source.top +source.height)
    ];
    this.line = new fabric.Line(points, {
      id: `underline-${source.id}`,
      strokeWidth: 5,
      clearOnReset: true,
      opacity: 1,
      optionId: source.optionId,
      fill: '',
      stroke: 'red',
      originX: 'center',
      originY: 'center',
      selectable: false,
      evented: false
    });

    this._canvas.addObject(this.line);
    this.line.moveTo(10000);

    this.line.animate(
      {
        x2: source.aCoords?.br.x ?? 0
      },
      {
        onChange: () => {
          this.line.bringToFront();
          this._canvas.canvasRenderAll();
        },
        onComplete: () => {},
        duration: 400
      }
    );

    source.set('evented', false);
    source.set('opacity', 0);
    source.set('isDisable', true);
    this._canvas.canvasRenderAll();
  };

  closeDrawingMode(canvas: any,selectedTool: string) {
    canvas.cancelDraw();
    canvas.closeDrawingMode()

  }
  openDrawingMode(canvas: any, selectedTool: string) {
    canvas.openDraw();
    canvas.openDrawingMode()

  }

  renderActivityFiles = async (pageItem: PageItemCanvasModel, onQuestionFileClick: (file: any)=>void): Promise<void> => {
    const question = pageItem;
    const files:any[] =[];
    const backgroundCoordinate = this._canvas.getBackgroundImageCoordinate();
    const canvasSize= this._canvas.getCanvasSize();
    const scale = canvasSize.height / 849 / 4;
    const canvas = this._canvas;
    const onFileClick = onQuestionFileClick;

    for (const file of files) {
      if (file.fileType !== 40) {
        const left =file.x + backgroundCoordinate.imgLeft;
        const top = file.y + backgroundCoordinate.imgTop;

        fabric.loadSVGFromString(SvgIcons.SoundIcon, (objects: any, options: any) => {
          const img = fabric.util.groupSVGElements(objects, options);
          img.set({
            left,
            top,
            scaleX: scale,
            scaleY: scale
          });
          img.set('pageIcon', true);
          img.set('selectable', false);
          img.set('erasable', false);
          img.set('id', `file-${file.id}`);
          img.set('name', `file-${file.id}`);
          img.on('mousedown', () => {
            onFileClick(file);
          });
          canvas.addObject(img);
          canvas.canvasRenderAll();
        });
      }
    }
    canPlaySound = !question.hasCompleteButton;
  };

  getOpenedAnswers = (): string[] => {
    return openedAnswerIds;
  };

  resetOpenedAnswers = async (): Promise<void> => {
    openedAnswerIds = [];
  };

  addOpenedAnswers = async (id: string): Promise<void> => {
    openedAnswerIds.push(id);
  };

  removeOpenedAnswers = async (id: string): Promise<void> => {
    openedAnswerIds = openedAnswerIds.filter((x) => x !== id);
  };

  playSound = async (type: 'solve' | boolean): Promise<void> => {
    // if (type === 'solve') {
    //   const audio = new Audio(solveSound);
    //   audio.play();
    //   return;
    // }
    // if (canPlaySound) {
    //   const audio = new Audio(type ? correctSound : wrongSound);
    //   audio.play();
    // }
  };


  intersectsY(a: any, b: any): boolean {
    return (
      (a.targetTop <= b.targetTop && a.targetTop + a.targetHeight >= b.targetTop) ||
      (b.targetTop <= a.targetTop && b.targetTop + b.targetHeight >= a.targetTop)
    );
  }

  getTargetCenter = (target: any): { x: number; y: number } => {
    const xCoordinate =
      target.lineCoords.bl.x + (target.lineCoords.br.x - target.lineCoords.bl.x) / 2;
    const yCoordinate =
      target.lineCoords.tl.y + (target.lineCoords.bl.y - target.lineCoords.tl.y) / 2;
    return { x: xCoordinate, y: yCoordinate };
  };

  destroy (): void {}
  onComplete (): void {}
  onReset (): void {}
  onShowAnswer(): void {}
  onShowPreviousAnswer(): void {}
  onShowNextAnswer(): void {}

  onZoomChange(): void {}

  doMouseUp(event: any): void {}

  doMouseDown(event: any): void {}

  doMouseMove(event: any): void {}

  doMouseOut(event: any): void {}
}

export default FabricCanvasExercise;
